import React from 'react'
// hooks
import { useModalData } from 'hooks/index'
import { useMediaQuery } from '@mui/material'
// view components
import Matrix from './components/Matrix'
// constants
import { Modals } from 'constants/modals'
import { SCREEN_SIZE } from 'constants/screenSize'
// themes
import { CloseIcon } from 'components/UI/Icons'
// context
import { RiskTemplateAPIContext } from 'containers/Risks/RiskTemplate/Edit/layers/API'
// views
import { Description, Header, ModalContent, StyledModal } from './views'
// utils
import debounce from 'lodash/debounce'

const PAPER_PROPS = {
  style: {
    height: '90vh'
  }
}

const PAPER_PROPS_MOBILE = {
  style: {
    width: '100vw',
    height: '100vh',
    margin: 0,
    maxHeight: '100vh',
    borderRadius: 0
  }
}

const RiskMatrixModal: React.FC = () => {
  const {
    hideModal,
    modalData: { isOpen, name, disabled, field, value }
  } = useModalData({ modalType: Modals.RISK_MATRIX_MODAL })

  const { updateField, isRisk } = React.useContext(RiskTemplateAPIContext)

  const isTablet = useMediaQuery(SCREEN_SIZE.TABLET)
  const appetiteEnabled = field?.settings.appetiteEnabled

  const debouncedUpdateMatrix = React.useCallback(
    debounce((matrix) => {
      if (!disabled) {
        updateField(
          {
            ...field,
            name: field.label,
            settings: matrix
          },
          field
        )
      }
    }, 1000),
    [field]
  )

  if (!field) {
    return null
  }

  const matrix = {
    ...field.settings,
    selectedOption: value.value || value,
    topSection: appetiteEnabled
      ? field.settings.topSection.map((row) =>
          row.map((cell) => {
            if (value.selectedTs?.some((item) => item.id === cell.id)) {
              return { ...cell, selected: true }
            }

            return cell
          })
        )
      : field.settings.topSection
  }

  return (
    <StyledModal
      width={'xl'}
      isOpen={isOpen}
      hideModal={hideModal}
      PaperProps={isTablet ? PAPER_PROPS_MOBILE : PAPER_PROPS}>
      <Header>
        <span>{field.label}</span>
        {appetiteEnabled && isRisk && (
          <Description>
            For 1 or more of the categories select a cell level which best describes the potential consequence or impact
            should the risk occur
          </Description>
        )}
        <CloseIcon onClick={hideModal} />
      </Header>
      <ModalContent>
        <Matrix
          value={matrix}
          fieldName={name}
          label={field.label}
          disabled={disabled}
          hideModal={hideModal}
          onChange={debouncedUpdateMatrix}
          appetiteEnabled={appetiteEnabled}
        />
      </ModalContent>
    </StyledModal>
  )
}

export default RiskMatrixModal
